import Http from '@/core/http';
import PrettyConsole from '@/utils/pretty-console';
import * as Sentry from '@sentry/vue';
import { useAuthStore } from '@/stores/auth.ts';

export default class Reporting {
  constructor() {
    this.logHttpResponses = true;
    this.sendRemote = process.env.SENTRY_ENVIRONMENT !== 'local';
  }

  report(error) {
    // Ignore HTTP errors
    if (error.response) {
      if (this.logHttpResponses) {
        if (error.response.status >= 500) {
          console.error(error);
        }
      }

      return;
    }

    // Ignore Network Errors. This includes no internet etc.
    if (!error.response && (error.code === 'ECONNABORTED' || error.message === 'Network Error' || error.message === 'timeout of 0ms exceeded')) {
      return;
    }

    // Ignore canceled http requests
    if (Http.isCancel(error)) {
      if (this.logHttpResponses) {
        console.info('Request cancelled.', error);
      }

      return;
    }

    // Ignore chrome + grammarly error
    if (error.message === 'ResizeObserver loop limit exceeded') {
      return;
    }

    if (error.message === 'Request aborted') {
      return;
    }

    // Ignore router errors
    if (error._isRouter) {
      console.error(error._isRouter);

      return;
    }

    if (error instanceof Error) {
      this.reportException(error);
    }

    console.error(error);
  }

  reportException(exception) {
    if (!this.sendRemote) {
      return;
    }

    PrettyConsole.info('Exception reported.');
    this._updateContext();
    Sentry.captureException(exception);
  }

  _updateContext() {
    const authStore = useAuthStore();

    if (authStore.user) {
      const userData = {
        email: authStore.user?.profile?.email,
        id: authStore.user.profile.id,
      };

      if (authStore.company) {
        userData.company_id = authStore.company.id;
      } else {
        userData.company_id = null;
      }

      Sentry.setUser(userData);
    } else {
      Sentry.setUser(null);
    }
  }
}
